import { render, staticRenderFns } from "./investment-type.vue?vue&type=template&id=a58f01d0&scoped=true"
import script from "./investment-type.vue?vue&type=script&lang=js"
export * from "./investment-type.vue?vue&type=script&lang=js"
import style0 from "./investment-type.vue?vue&type=style&index=0&id=a58f01d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58f01d0",
  null
  
)

export default component.exports